<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t2">Monsters and Men Box Set</span></p>
<p class="p0">By R.W. Clinger</p>
<p class="p2"><a id="a3"></a> </p>
<p class="p2"><a href="#/004#a28">Vonderlust</a></p>
<p class="p2"> </p>
<p class="p2"><span href="#/005#a29" title="Link target outside of Sample">The 13th Warlock</span></p>
<p class="p2"> </p>
<p class="p2"><span href="#/006#a30" title="Link target outside of Sample">Something Purple This Way Comes</span></p>
<p class="p4"><span href="#/006#a31" title="Link target outside of Sample">Prologue</span></p>
<p class="p4"><span href="#/007#a32" title="Link target outside of Sample">Part 1: Night</span></p>
<p class="p4"><span href="#/012#a33" title="Link target outside of Sample">Part 2: Morning</span></p>
<p class="p4"><span href="#/015#a34" title="Link target outside of Sample">Epilogue</span></p>
<p class="p4"> </p>
<p class="p2"><span href="#/016#a35" title="Link target outside of Sample">Blood on My Hands</span></p>
<p class="p4"><span href="#/016#a36" title="Link target outside of Sample">Chapter 1</span></p>
<p class="p4"><span href="#/017#a37" title="Link target outside of Sample">Chapter 2</span></p>
<p class="p4"><span href="#/018#a38" title="Link target outside of Sample">Chapter 3</span></p>
<p class="p4"><span href="#/019#a39" title="Link target outside of Sample">Chapter 4</span></p>
<p class="p4"><span href="#/020#a40" title="Link target outside of Sample">Chapter 5</span></p>
<p class="p4"><span href="#/021#a41" title="Link target outside of Sample">Chapter 6</span></p>
<p class="p4"><span href="#/022#a42" title="Link target outside of Sample">Chapter 7</span></p>
<p class="p4"><span href="#/023#a43" title="Link target outside of Sample">Chapter 8</span></p>
<p class="p4"><span href="#/024#a44" title="Link target outside of Sample">Chapter 9</span></p>
<p class="p4"><span href="#/025#a45" title="Link target outside of Sample">Chapter 10</span></p>
<p class="p4"><span href="#/026#a46" title="Link target outside of Sample">Chapter 11</span></p>
<p class="p4"><span href="#/027#a47" title="Link target outside of Sample">Chapter 12</span></p>
<p class="p4"><span href="#/028#a48" title="Link target outside of Sample">Chapter 13</span><a href="#/#a27"></a></p>
<h1 class="h10"><a id="ncx47"></a><a id="a27"></a> </h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?1f376b85